import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { UserContext } from '../../App'
import cookies from '../../CommonFunction/cookies'
import {
  fetchIndividualData,
  fetchOrganizationData
} from '../../API/ClevDocContact'
import { showFailed } from '../../CommonFunction/SweetAlert'
import { MdEmail } from 'react-icons/md'
import toast from 'react-hot-toast'
import { requestFCMToken } from '../../firebaseUtils'
// import Loader from "../../CommonFunction/Loader";

const Login = () => {
  // const { state, dispatch } = useContext(UserContext)
  const [formData, setFormData] = useState({
    email: '',
    role: 'user',
    type: 'login'
  })

  // const [isPreviewOpen, setPreviewOpen] = useState(false);
  const [otp, setOtp] = useState('')
  const [timer, setTimer] = useState(10)
  const [showResend, setShowResend] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingVerify, setIsLoadingVerify] = useState(false)
  const [loading, setLoading] = useState(false)
  const [bankLoading, setBankLoading] = useState(false)
  const [timerMsg, setTimerMsg] = useState(false)
  const [errorOTP, setErrorOTP] = useState('')
  const [emailError, setEmailError] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const { email, role } = location.state || {}
  const [fcmToken, setFcmToken] = useState(null)
  const [bankerData, setBankerData] = useState({
    userID: '',
    password: ''
  })

  const [chooseRole, setChooseRole] = useState('borrower')

  useEffect(() => {
    console.log('first--', email, role)
    if (role && email) {
      setFormData({ ...formData, role: role, email: email })
    }
    return () => {
      setFormData({
        role: 'user',
        type: 'login'
      })
    }
  }, [])

  useEffect(() => {
    const fetchFCMToken = async () => {
      try {
        const token = await requestFCMToken()
        setFcmToken(token)
        console.log("token", token);
      }
      catch (err) {
        console.log("Error -------", err);

      }
    }
    fetchFCMToken()
  },[])

  const handleRoleChange = event => {
    setChooseRole(event.target.value)
  }

  const handleChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    setEmailError('')
  }

  const handleBankChange = e => {
    const { name, value } = e.target
    setBankerData(prevData => ({
      ...prevData,
      [name]: name === 'userID' ? value.toUpperCase() : value
    }))
  }

  const handleOptionChange = event => {
    setFormData({ ...formData, role: event.target.value })
  }

  const CountDown = () => {
    // Reset timer
    setTimer(60) // Reset timer to 10 seconds
    setShowResend(false)

    // Start timer countdown
    const interval = setInterval(() => {
      setTimer(prevTimer => {
        if (prevTimer === 0) {
          clearInterval(interval)
          setShowResend(true)
          return 0
        }
        return prevTimer - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }

  // Borrower Login
  const getOTP = async e => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    if (!formData.email) {
      setEmailError('Email is required!')
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      setEmailError('Email is invalid')
    } else {
      setLoading(true)
      let dataToSend = {}
      try {
        if (formData.role === 'user') {
          dataToSend = {
            email: formData.email,
            role: formData.role,
            fcm_token: fcmToken
          }
        } else if (formData.role === 'entity') {
          dataToSend = {
            email: formData.email,
            role: 'entity',
            fcm_token: fcmToken
          }
        }

        if (chooseRole === 'borrower') {
          setIsLoading(true)
          const response = await fetch(
            `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/auth/login`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(dataToSend)
            }
          )
          const result = await response.json()

          if (response.ok && result.code === 200) {
            setLoading(false)
            setTimerMsg(true)
            toast.success(`${result.message}`)
            CountDown()
          } else {
            console.error('Login failed:', result.error[0])
            setLoading(false)
            setIsLoading(false)
            showFailed('Failed.', `${result.error[0]}`)
            navigate('/register', { state: { role: formData.role, email: formData?.email} })
          }
        }
      } catch (error) {
        showFailed('Failed.', `${error}`)
        console.error('Login error:', error)
      }
    }
  }

  // Bank Login
  const bankLogin = async e => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    setBankLoading(true)
    try {
      if (chooseRole === 'bank') {
        const response = await fetch(
          `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/auth/bank/login`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              system_id: bankerData.userID,
              password: bankerData.password
            })
          }
        )
        const result = await response.json()

        if (response.ok) {
          cookies.set('jwt', result.accessToken, {
            path: '/',
            Domain: 'https://clevdoc.com',
            secure: true,
            sameSite: 'None'
          })
          setBankLoading(false)
          toast.success(`You Are Successfully Login.`)
          // dispatch({ type: 'USER', payload: true })
          navigate('/banking/bankDashboard')
        } else {
          setBankLoading(false)
          showFailed('Failed.', `${result.error[0]}`)
          console.error('Login failed:', response.statusText)
        }
      }
    } catch (error) {
      setBankLoading(false)
      showFailed('Failed.', `${error}`)
      console.error('Login error:', error)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (chooseRole === 'borrower') {
      await otpVerify(e)
    } else if (chooseRole === 'bank') {
      await bankLogin(e)
    }
  }

  const fetchDataAndUpdateUserData = async jwtToken => {
    try {
      const data = await fetchIndividualData(jwtToken)
      if (data?.step === 2) {
        navigate('/banking/borrowerDashboard/inbox')
      } else if (data?.step === 1) {
        navigate('/banking/borrowerDashboard/1')
      }
    } catch (error) {
      console.error('Error retrieving user data after otp:', error)
    }
  }

  const fetchOrgDataAndUpdate = async jwtToken => {
    try {
      const data = await fetchOrganizationData(jwtToken)
      if (data?.step === 2) {
        navigate('/banking/borrowerDashboard/inbox')
      } else if (data?.step === 1) {
        navigate('/banking/borrowerDashboard/2')
      }
    } catch (error) {
      console.error('Error retrieving organization data:', error)
    }
  }

  // OTP verify
  const otpVerify = async e => {
    e.preventDefault()
    if (!otp) {
      setErrorOTP('Verification code Required')
    } else if (otp.length < 5) {
      setErrorOTP('OTP should be 5 number')
    } else {
      setIsLoadingVerify(true)
      try {
        const response = await fetch(
          `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/auth/verify`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              code: otp,
              email: formData.email,
              role: formData.role,
              type: formData.type
            })
          }
        )

        const result = await response.json()

        if (response.status === 200 && formData.role === 'user') {
          cookies.set('jwt', result.accessToken, {
            path: '/',
            Domain: 'https://clevdoc.com',
            secure: true,
            sameSite: 'None'
          })
          const jwtToken = cookies.get('jwt')
          await fetchDataAndUpdateUserData(jwtToken)
          toast.success(`You Are Successfully Login.`)
          // dispatch({ type: 'USER', payload: true })
          navigate('/banking/borrowerDashboard/1')
          setIsLoadingVerify(false)
        } else if (response.status === 200 && formData.role === 'entity') {
          cookies.set('jwt', result.accessToken, {
            path: '/',
            Domain: 'https://clevdoc.com',
            secure: true,
            sameSite: 'None'
          })
          const jwtToken = cookies.get('jwt')
          await fetchOrgDataAndUpdate(jwtToken)
          toast.success(`You Are Successfully Login.`)
          // dispatch({ type: 'USER', payload: true })
          navigate('/banking/borrowerDashboard/2')
          setIsLoadingVerify(false)
        } else {
          showFailed('Failed.', `${result.error[0]}`)
          setOtp('')
          console.error('OTP verification failed:', result.error)
          setIsLoadingVerify(false)
        }
      } catch (error) {
        showFailed('Failed.', `${error}`)
        console.error('Error during OTP verification:', error)
        setIsLoadingVerify(false)
      }
    }
  }

 return (
  <>
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 md:pt-32 pb-12 font-avenir">

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-start">

        {/* ================= LEFT SIDE ================= */}
        <div className="block text-center mt-4 lg:mt-7">

          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-bgclr leading-tight">
            Streamlined Digital Communications,
          </h1>

          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-bgclr leading-tight mt-1">
            Seamless Compliance
          </h1>

          <p className="mt-5 text-sm sm:text-base lg:text-lg">
            Efficient Financial Communications, Simplified Processes
          </p>

          {/* Responsive Image */}
          <div className="w-full flex justify-center mt-6 lg:mt-8">
            <img
              src="https://cdn.clevdoc.com/uploads//blog/images/WhatsApp+Image+2026-08-11+at+4.04.05+PM+(1).jpeg"
              alt="Banking Communication Platform"
              className="
                w-full
                max-w-[650px]
                h-auto
                max-h-[500px]
                object-contain
                rounded-2xl
              "
            />
          </div>

        </div>


        {/* ================= RIGHT SIDE ================= */}
        <div className="w-full max-w-2xl mx-auto lg:mt-16">

          <div className="w-full">

            {/* Welcome */}
            <h1 className="text-3xl sm:text-4xl font-semibold text-center lg:text-left text-bgclr mb-4">
              Welcome!
            </h1>

            <h1 className="text-base sm:text-lg lg:text-xl font-bold text-bgclr mb-6 text-center lg:text-left">
              Login to your Banking Communication Platform.
            </h1>


            <form onSubmit={e => handleSubmit(e)}>

              {/* ================= SELECT ROLE ================= */}
              <div className="mb-6 p-4 bg-[#E8ECF0] font-semibold rounded-md text-txtclr2">

                <label className="block text-sm font-medium mb-2">
                  Select Role
                  <span className="text-red-600">*</span>
                </label>

                <select
                  className="
                    block
                    w-full
                    p-3
                    text-sm
                    sm:text-base
                    text-gray-500
                    bg-white
                    border
                    border-gray-300
                    rounded-md
                    shadow-sm
                    focus:outline-none
                  "
                  value={chooseRole}
                  onChange={handleRoleChange}
                >
                  <option value="borrower">
                    Borrower
                  </option>

                  <option value="bank">
                    Bank
                  </option>
                </select>

              </div>


              {/* ================= BORROWER LOGIN ================= */}
              {chooseRole === "borrower" && (
                <div>

                  {/* Borrower Type */}
                  <div className="mb-5 text-txtclr3 font-semibold">

                    <label className="block text-sm font-medium text-txtclr2 mb-2">
                      Borrower Type
                      <span className="text-red-600">*</span>
                    </label>

                    <div className="flex flex-wrap gap-5">

                      <label className="flex items-center">
                        <input
                          type="radio"
                          value="user"
                          checked={formData.role === "user"}
                          onChange={handleOptionChange}
                          className="accent-txtclr3 mr-2"
                        />
                        Individual
                      </label>

                      <label className="flex items-center">
                        <input
                          type="radio"
                          value="entity"
                          checked={formData.role === "entity"}
                          onChange={handleOptionChange}
                          className="accent-txtclr3 mr-2"
                        />
                        Organization
                      </label>

                    </div>

                  </div>


                  {/* ================= EMAIL + OTP ================= */}
                  <div className="grid grid-cols-1 sm:grid-cols-9 mt-6 gap-3">

                    {/* Email */}
                    <div className="sm:col-span-7">

                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-txtclr2 mb-2"
                      >
                        Email ID
                        <span className="text-red-600">*</span>
                      </label>

                      <div className="relative">

                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="pl-10 input-style w-full"
                          placeholder="Email ID"
                          disabled={isLoading}
                        />

                        <MdEmail
                          className="
                            absolute
                            left-4
                            top-1/2
                            -translate-y-1/2
                            text-gray-400
                            pointer-events-none
                          "
                        />

                      </div>

                    </div>


                    {/* Get OTP */}
                    <div className="sm:col-span-2 flex items-end">

                      <button
                        type="button"
                        onClick={getOTP}
                        className="
                          w-full
                          h-[46px]
                          text-center
                          bg-bgclr
                          hover:bg-bgclr6
                          text-txtclr
                          font-semibold
                          rounded-md
                          focus:outline-none
                          disabled:opacity-60
                        "
                        disabled={isLoading}
                      >
                        {loading ? "Sending" : "Get OTP"}
                      </button>

                    </div>

                  </div>


                  {/* ================= EMAIL ERROR / TIMER ================= */}
                  <div className="min-h-[36px] mt-2">

                    {emailError && (
                      <span className="text-red-600 font-semibold text-sm">
                        {emailError}
                      </span>
                    )}

                    {timerMsg && (
                      <div className="flex flex-wrap justify-end items-center gap-2 text-sm">

                        {timer > 0 && (
                          <div className="text-gray-700 italic">
                            Resend OTP in{" "}
                            <span className="text-green-800 font-semibold">
                              {Math.floor(timer / 60)}:
                              {timer % 60 < 10
                                ? `0${timer % 60}`
                                : timer % 60}
                            </span>
                          </div>
                        )}

                        {showResend && (
                          <button
                            type="button"
                            className="text-txtclr3 underline italic"
                            onClick={e => getOTP(e)}
                          >
                            Resend OTP
                          </button>
                        )}

                      </div>
                    )}

                  </div>


                  {/* ================= VERIFICATION CODE ================= */}
                  <div className="mt-4">

                    <label
                      htmlFor="otp"
                      className="block text-sm font-medium text-txtclr2 mb-2"
                    >
                      Verification Code
                      <span className="text-red-600">*</span>
                    </label>

                    <input
                      type="password"
                      id="otp"
                      name="otp"
                      maxLength="5"
                      value={otp}
                      onInput={e => {
                        e.target.value = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        )
                      }}
                      onChange={e => {
                        setOtp(e.target.value)
                        setErrorOTP("")
                      }}
                      className="input-style w-full"
                      placeholder="Enter your verification Code"
                      disabled={!timerMsg}
                    />

                    {errorOTP && (
                      <span className="text-red-600 font-semibold text-sm">
                        {errorOTP}
                      </span>
                    )}

                  </div>


                  {/* ================= LOGIN BUTTON ================= */}
                  <div className="text-center mt-6">

                    <button
                      type="submit"
                      className="
                        w-full
                        bg-bgclr
                        hover:bg-bg-btnhover
                        text-txtclr
                        px-4
                        py-3
                        rounded-md
                        font-semibold
                        transition
                        disabled:opacity-60
                      "
                      disabled={!timerMsg || isLoadingVerify}
                    >
                      {isLoadingVerify
                        ? "Logging in..."
                        : "Log In"}
                    </button>

                  </div>


                  {/* ================= REGISTER ================= */}
                  <div className="text-center pt-6 hover:underline">

                    <Link to="/register">
                      Don't have an account? Register
                    </Link>

                  </div>

                </div>
              )}


              {/* ================= BANK LOGIN ================= */}
              {chooseRole === "bank" && (
                <div>

                  {/* User ID */}
                  <div className="mb-5">

                    <label
                      htmlFor="userID"
                      className="block text-sm font-medium text-txtclr2 mb-2"
                    >
                      User ID
                      <span className="text-red-600">*</span>
                    </label>

                    <input
                      type="text"
                      id="userID"
                      name="userID"
                      value={bankerData.userID}
                      onChange={handleBankChange}
                      className="input-style w-full"
                      placeholder="Enter your User ID"
                      required
                    />

                  </div>


                  {/* Password */}
                  <div className="mb-5">

                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-txtclr2 mb-2"
                    >
                      Password
                      <span className="text-red-600">*</span>
                    </label>

                    <input
                      type="password"
                      id="password"
                      name="password"
                      onChange={handleBankChange}
                      value={bankerData.password}
                      className="input-style w-full"
                      placeholder="Enter your Password"
                      required
                    />

                  </div>


                  {/* Bank Login */}
                  <div className="text-center mt-6">

                    <button
                      type="submit"
                      className="
                        w-full
                        bg-bgclr
                        hover:bg-bgclr6
                        text-txtclr
                        px-4
                        py-3
                        rounded-md
                        font-semibold
                        disabled:opacity-60
                      "
                      disabled={bankLoading}
                    >
                      {bankLoading
                        ? "Logging in..."
                        : "Log In"}
                    </button>

                  </div>


                  {/* Forgot Password */}
                  <div className="text-center text-gray-500 mt-6 hover:underline">

                    <Link to="/forgotPass">
                      Forgot Password ?
                    </Link>

                  </div>

                </div>
              )}

            </form>

          </div>

        </div>

      </div>
    </div>
  </>
)
}

export default Login
